// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Box.css
 */

.box {
    padding: 3px;
}

.box-content {
    color: #333;
    border: 1px gray solid;
    min-width: 100px;
    background: rgba(111, 168, 220, .66)
}

.box-padding {
    color: #333;
    border: 1px gray dashed;
    background: rgba(147, 196, 125, .55)
}

.box-border {
    color: #333;
    border: 1px #000 solid;
    background: rgba(255, 229, 153, .66)
}

.box-margin {
    color: #333;
    border: 1px dashed;
    background: rgba(246, 178, 107, .66)
}

.box-position {
    border: 1px gray dotted
}

.box-border,
.box-content,
.box-margin,
.box-padding,
.box-position {
    position: relative;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    font-family: "Segoe UI", Tahoma, sans-serif;
    font-size: 12px;
    white-space: nowrap
}

.box-label {
    position: absolute;
    margin-left: 3px;
    padding: 1px 2px 0;
}

.box * {
    box-sizing: content-box;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-family: 'Segoe UI', Tahoma, sans-serif !important;
}

.box-top,
.box-left,
.box-right,
.box-bottom {
    display: inline-block
}

.box-left,
.box-right {
    vertical-align: middle;
    padding: 0 3px;
}

.box-top,
.box-bottom {
    padding: 2px 0;
}

.box-content {
    padding: 2px;
}`, "",{"version":3,"sources":["webpack://./src/lib/box.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB;AACJ;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB;AACJ;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;IAKI,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,2CAA2C;IAC3C,eAAe;IACf;AACJ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,iBAAiB;IACjB,sDAAsD;AAC1D;;AAEA;;;;IAII;AACJ;;AAEA;;IAEI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/**\n * Box.css\n */\n\n.box {\n    padding: 3px;\n}\n\n.box-content {\n    color: #333;\n    border: 1px gray solid;\n    min-width: 100px;\n    background: rgba(111, 168, 220, .66)\n}\n\n.box-padding {\n    color: #333;\n    border: 1px gray dashed;\n    background: rgba(147, 196, 125, .55)\n}\n\n.box-border {\n    color: #333;\n    border: 1px #000 solid;\n    background: rgba(255, 229, 153, .66)\n}\n\n.box-margin {\n    color: #333;\n    border: 1px dashed;\n    background: rgba(246, 178, 107, .66)\n}\n\n.box-position {\n    border: 1px gray dotted\n}\n\n.box-border,\n.box-content,\n.box-margin,\n.box-padding,\n.box-position {\n    position: relative;\n    display: inline-block;\n    text-align: center;\n    vertical-align: middle;\n    font-family: \"Segoe UI\", Tahoma, sans-serif;\n    font-size: 12px;\n    white-space: nowrap\n}\n\n.box-label {\n    position: absolute;\n    margin-left: 3px;\n    padding: 1px 2px 0;\n}\n\n.box * {\n    box-sizing: content-box;\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    font-family: 'Segoe UI', Tahoma, sans-serif !important;\n}\n\n.box-top,\n.box-left,\n.box-right,\n.box-bottom {\n    display: inline-block\n}\n\n.box-left,\n.box-right {\n    vertical-align: middle;\n    padding: 0 3px;\n}\n\n.box-top,\n.box-bottom {\n    padding: 2px 0;\n}\n\n.box-content {\n    padding: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
